/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryDeleteCommentRequest
 */
export interface RevisdomAPIViewModelsEntryDeleteCommentRequest {
    /**
     * Silinecek comment'in ID'si
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryDeleteCommentRequest
     */
    id: number;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryDeleteCommentRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryDeleteCommentRequest(value: object): value is RevisdomAPIViewModelsEntryDeleteCommentRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RevisdomAPIViewModelsEntryDeleteCommentRequestFromJSON(json: any): RevisdomAPIViewModelsEntryDeleteCommentRequest {
    return RevisdomAPIViewModelsEntryDeleteCommentRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDeleteCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryDeleteCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function RevisdomAPIViewModelsEntryDeleteCommentRequestToJSON(json: any): RevisdomAPIViewModelsEntryDeleteCommentRequest {
    return RevisdomAPIViewModelsEntryDeleteCommentRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDeleteCommentRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryDeleteCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

